import BaseStore from '@/store/base-store'

const options = {}
export default new BaseStore('messages', options)



// WEBPACK FOOTER //
// ./src/store/modules/messages.store.js